import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state()  {
    return {
      user: JSON.parse(localStorage.getItem("user") || '{}'),
      token: localStorage.getItem("token")
    }
  },
  mutations: {
    user:(state,val) =>{
      if(!val){
        return
      }
      localStorage.setItem("user", JSON.stringify(val.user||{}));
      localStorage.setItem("token", val.token||'')
      state.user = val.user
      state.token = val.token
    }
  },
  getters:{
    user: state =>  state.user || JSON.parse(localStorage.getItem("user") || '{}'),
    token: state => state.token || localStorage.getItem("token")||'',
    hasToken: state => state.token != 'null' && state.token != 'undefined' && !!state.token,
  },
  actions: {
    login({ commit }, user) {
      return api.login(user).then(res => {
        commit('user', res)
        return res
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('user', { user: {}, token: '' })
        resolve && resolve()
      })
    }
  },
  modules: {
  }
})
